import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="form"
export default class extends Controller {
  static values = { submit: Boolean }

  connect() {
    this.element[this.identifier] = this;

    this.submitWithDebounce = debounce(this.submit, 500);

    if (this.submitValue) setTimeout(this.submit.bind(this), 50);

    // Dont post with turbo if the form is outside a modal
    if (this.element.parentNode.classList.contains('layout__content')) {
      this.element.dataset.turbo = 'false'
    }

    this.element.addEventListener('submit', (e) => {
      this.element.querySelector('*[type="submit"]').disabled = true;
    });
  }

  submit() {
    this.element.requestSubmit()
  }

  fill(event) {
    event.preventDefault()
    this.element.querySelector(event.params.input).value = event.params.value
  }

  refresh(e) {
    e.preventDefault();

    let input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'refresh'
    input.value = 1
    this.element.appendChild(input)

    this.submit();
  }
}
